export default "__VITE_ASSET__19d465f5__"